function buildCopyLinkHtmlString(url) {
  return `
  <!DOCTYPE html>
  <html>
  <head></head>
  <style>
    body {
      margin: 0;
    }
    svg {
      box-sizing: border-box;
      cursor: pointer;
      display: block;
      transform: rotate(45deg);
      cursor: copy;
    }
    button {
      border: none;
      background: transparent;
      padding: 0;
      margin: 0 16px;
    }
    button:active > svg,
    button:focus > svg {
      stroke: #2955de;
    }
  </style>
  <body>
    <button id='copy'>
      <svg
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        xmlns:xlink='http://www.w3.org/1999/xlink'
        width='23'
        height='23'
        viewBox='0 0 24 24'
        fill='none'
        stroke='#40485a'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
        >
          <path d='M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3'></path>
          <line x1='8' y1='12' x2='16' y2='12'></line>
        </svg>
      </button>
      <input type="text" id="_i" hidden></input>
      <script>
        copy.onclick = function() {
          _i.value = window.decodeURIComponent("${url}");
          _i.hidden = false;
          _i.select();
          _i.focus();
          document.execCommand("copy");
          _i.hidden = true;
          _i.value = "";
        };
      </script>
    </body>
  </html>
`;
}

export default buildCopyLinkHtmlString;
